import { FC, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  DeleteGuestModal,
  EditGuestModal,
  EditGuestStatusModal,
} from "Bands/containers";
import { dispatchGetEventGuests } from "Bands/state";
import {
  IEventGuest,
  IEventGuestStatus,
  IGuestlistBlock,
  IGuestlistBlockStatus,
} from "Bands/types";
import { copy } from "shared/assets";
import { Title } from "shared/components";
import { GuestsTable } from "./GuestsTable";
import { StyledGuestTableWrapper } from "./style";

const viewCopy = copy.guestlistBlock.guests.view;

interface GuestOverviewProps {
  block: IGuestlistBlock;
  showActions?: boolean;
}

export interface IGuestStatusModal {
  guest: IEventGuest;
  status: IEventGuestStatus;
}

export const GuestOverview: FC<GuestOverviewProps> = ({
  block,
  showActions = true,
}) => {
  const [showEditModal, setShowEditModal] = useState<IEventGuest | null>();
  const [showDeleteModal, setShowDeleteModal] = useState<IEventGuest | null>();
  const [showStatusModal, setShowStatusModal] =
    useState<IGuestStatusModal | null>();

  const dispatch = useDispatch();

  const fetchGuests = useCallback(
    (page: number = 1) => {
      dispatchGetEventGuests({
        dispatch,
        blockId: block.id,
        page,
        isRecursive: !showActions,
      });
    },
    [block.id, dispatch, showActions]
  );

  useEffect(() => {
    fetchGuests();
  }, [fetchGuests]);

  return (
    <StyledGuestTableWrapper size="m">
      <Title
        asComponent="h3"
        size="m"
        printOptions={{
          margin: "8px 0 0 8px",
          display: showActions ? "block" : "none",
        }}
      >
        {viewCopy.title}
      </Title>
      <GuestsTable
        blockId={block.id}
        fetchGuests={fetchGuests}
        setShowEditModal={setShowEditModal}
        setShowDeleteModal={setShowDeleteModal}
        setShowStatusModal={setShowStatusModal}
        showActions={
          block.status !== IGuestlistBlockStatus.closed && showActions
        }
      />
      {showEditModal && (
        <EditGuestModal
          block={block}
          guest={showEditModal}
          handleClose={() => setShowEditModal(null)}
        />
      )}
      {showDeleteModal && (
        <DeleteGuestModal
          blockId={block.id}
          guest={showDeleteModal}
          handleClose={() => setShowDeleteModal(null)}
        />
      )}
      {showStatusModal && (
        <EditGuestStatusModal
          blockId={block.id}
          guest={showStatusModal.guest}
          newStatus={showStatusModal.status}
          handleClose={() => setShowStatusModal(null)}
        />
      )}
    </StyledGuestTableWrapper>
  );
};
